// First-visit-of-the-day glitter welcome effect.
// Fires once per calendar day, respects prefers-reduced-motion, runs only
// after the window 'load' event (never competes with LCP/FCP measurement),
// and uses a lighter particle count on narrow (mobile) viewports.
(function () {
  var STORAGE_KEY = 'btt-glitter-last-shown';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var today = new Date().toISOString().slice(0, 10);
  try {
    if (localStorage.getItem(STORAGE_KEY) === today) return;
  } catch (e) {
    return; // localStorage unavailable (private browsing etc.) - skip quietly
  }

  var isMobile = window.matchMedia('(max-width: 749px)').matches;
  var colors = ['#B8935A', '#E7CFA6', '#F3E6DA', '#9C5A2A', '#FDF6EC'];

  function runEffect() {
    var overlay = document.createElement('div');
    overlay.style.cssText =
      'position:fixed;inset:0;pointer-events:none;z-index:9999;overflow:hidden;';
    document.body.appendChild(overlay);

    function cleanupOverlay() {
      setTimeout(function () {
        if (overlay.parentNode) overlay.remove();
      }, 2600);
    }

    function particle(x, y, size, color, star) {
      var d = document.createElement('span');
      d.style.cssText = 'position:absolute;pointer-events:none;';
      d.style.width = size + 'px';
      d.style.height = size + 'px';
      d.style.left = x + 'px';
      d.style.top = y + 'px';
      d.style.background = color;
      d.style.borderRadius = star ? '2px' : '50%';
      if (star) {
        d.style.clipPath =
          'polygon(50% 0%,63% 38%,100% 50%,63% 62%,50% 100%,37% 62%,0% 50%,37% 38%)';
      }
      overlay.appendChild(d);
      return d;
    }

    function explode(x, y, big) {
      var flash = particle(x - 16, y - 16, 32, '#FDF6EC', false);
      flash
        .animate(
          [
            { transform: 'scale(0.3)', opacity: 0.95 },
            { transform: 'scale(2.6)', opacity: 0 },
          ],
          { duration: 380, easing: 'ease-out' }
        )
        .addEventListener('finish', function () {
          flash.remove();
        });

      var count = isMobile ? (big ? 85 : 50) : (big ? 170 : 100);
      for (var i = 0; i < count; i++) {
        var star = Math.random() < 0.25;
        var size = star ? 5 + Math.random() * 5 : 2 + Math.random() * 3.5;
        var p = particle(x, y, size, colors[Math.floor(Math.random() * colors.length)], star);
        var angle = Math.random() * Math.PI * 2;
        var dist = 40 + Math.random() * 130;
        var dx = Math.cos(angle) * dist;
        var dy = Math.sin(angle) * dist + 35;
        var dur = 950 + Math.random() * 700;
        var rot = Math.random() * 360 - 180;

        var anim = p.animate(
          [
            { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1, offset: 0 },
            {
              transform:
                'translate(' + dx * 0.35 + 'px,' + (dy * 0.3 - 30) + 'px) scale(1) rotate(' +
                rot * 0.4 + 'deg)',
              opacity: 1,
              offset: 0.25,
            },
            {
              transform:
                'translate(' + dx * 0.7 + 'px,' + (dy * 0.65 - 15) + 'px) scale(0.8) rotate(' +
                rot * 0.75 + 'deg)',
              opacity: 0.5,
              offset: 0.6,
            },
            {
              transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.25) rotate(' + rot + 'deg)',
              opacity: 0,
              offset: 1,
            },
          ],
          { duration: dur, easing: 'ease-out' }
        );
        anim.addEventListener('finish', (function (el) {
          return function () {
            el.remove();
          };
        })(p));

        setTimeout(
          (function (el, d) {
            return function () {
              el.animate(
                [
                  { opacity: 1 },
                  { opacity: 0.2 },
                  { opacity: 1 },
                  { opacity: 0.3 },
                  { opacity: 1 },
                ],
                { duration: d * 0.75, iterations: 2 }
              );
            };
          })(p, dur),
          Math.random() * 180
        );
      }
    }

    function launchOne(peakX, peakY, startXOffset, opts) {
      opts = opts || {};
      var startX = 16 + startXOffset;
      var startY = window.innerHeight - 16;
      var rocket = particle(startX, startY, 6, '#FDF6EC', false);
      rocket.style.boxShadow = '0 0 6px 2px rgba(184,147,90,0.6)';

      var trailTimer = setInterval(function () {
        var rect = rocket.getBoundingClientRect();
        var t = particle(rect.left, rect.top, 3, '#E7CFA6', false);
        t.animate([{ opacity: 0.7 }, { opacity: 0 }], { duration: 280 }).addEventListener(
          'finish',
          function () {
            t.remove();
          }
        );
      }, 30);

      var anim = rocket.animate(
        [
          { transform: 'translate(0,0)' },
          { transform: 'translate(' + (peakX - startX) + 'px,' + (peakY - startY) + 'px)' },
        ],
        { duration: 520 + Math.random() * 100, easing: 'cubic-bezier(.25,.6,.3,1)' }
      );

      anim.addEventListener('finish', function () {
        clearInterval(trailTimer);
        rocket.remove();
        explode(peakX, peakY, opts.big);
      });
    }

    var w = window.innerWidth;
    var h = window.innerHeight;
    var targets = [
      { x: w * 0.18, y: h * 0.24, delay: 0, sx: 0, big: false },
      { x: w * 0.34, y: h * 0.16, delay: 280, sx: 10, big: false },
      { x: w * 0.50, y: h * 0.20, delay: 560, sx: 4, big: true },
    ];
    targets.forEach(function (t) {
      setTimeout(function () {
        launchOne(t.x, t.y, t.sx, { big: t.big });
      }, t.delay);
    });

    cleanupOverlay();
  }

  window.addEventListener('load', function () {
    setTimeout(runEffect, 400);
    try {
      localStorage.setItem(STORAGE_KEY, today);
    } catch (e) {}
  });
})();